import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NoDataService, Page } from '@root/service/no-data.service';
import { routes } from '@root/common/routes';
import { AppService } from '@root/app.service';
@Component({
  selector: 'host-hostex-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss'],
})
export class HostexDemoComponent implements OnInit {
  readonly routes: typeof routes = routes;

  get isInternational() {
    return this.app.app.international;
  }

  get img() {
    return this.isInternational ? '/assets/v4/calendar-demo.jpg' : '/assets/v4/calendar-demo-cn.png';
  }
  demoCardTitle;
  demoCardDesc;
  demoCardBtn;

  constructor(private noDataSrv: NoDataService, private router: Router, private app: AppService) {}

  ngOnInit() {
    if (!this.noDataSrv.hasChannelAccount) {
      this.demoCardTitle = 'default_page_html_no_account_title';
      this.demoCardDesc = 'default_page_html_no_account_desc';
      this.demoCardBtn = 'channel-account-list_ts_添加直连账号';
    } else {
      this.demoCardTitle = 'default_page_html_no_listings_title';
      this.demoCardDesc = 'default_page_html_no_listings_desc';
      this.demoCardBtn = 'channel-account_html-去关联房源';
    }
  }

  onStartUse() {
    this.noDataSrv.frontHideDemo(Page.Calendar);

    this.router.navigate([routes.Calendar]);
  }
}
